import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { login, AuthError } from '../services/auth'
import { validateLoginForm } from '../utils/validation'
import { EmailOrUsernameInput } from '../components/EmailOrUsernameInput'
import { PasswordInput } from '../components/PasswordInput'
import styles from './Login.module.css'

export default function Login() {
    const [emailOrUsername, setEmailOrUsername] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState('')
    const [fieldErrors, setFieldErrors] = useState({})
    const [loading, setLoading] = useState(false)
    const [isEmailOrUsernameValid, setIsEmailOrUsernameValid] = useState(false)
    const [isPasswordValid, setIsPasswordValid] = useState(false)
    const navigate = useNavigate()

    const submit = async e => {
        e.preventDefault()
        setError('')
        setFieldErrors({})

        // Frontend validation
        const validation = validateLoginForm({ emailOrUsername, password })
        if (!validation.isValid) {
            setFieldErrors(validation.errors)
            return
        }

        setLoading(true)

        try {
            await login(emailOrUsername, password)
            // Notify other tabs/windows of auth change
            window.dispatchEvent(new Event('auth-changed'))
            navigate('/')
        } catch (err) {
            if (err instanceof AuthError) {
                // Handle field-specific errors from backend
                if (Object.keys(err.fieldErrors).length > 0) {
                    setFieldErrors(err.fieldErrors)
                } else {
                    setError(err.message)
                }
            } else {
                setError(err.message || 'Login mislykkedes')
            }
        } finally {
            setLoading(false)
        }
    }

    const isFormValid = isEmailOrUsernameValid && isPasswordValid && !loading

    return (
        <div className={styles.container}>
            <form className={styles.card} onSubmit={submit}>
                <h2>Log ind</h2>

                <div>
                    <EmailOrUsernameInput
                        value={emailOrUsername}
                        onChange={setEmailOrUsername}
                        error={fieldErrors.emailOrUsername}
                        onValidationChange={setIsEmailOrUsernameValid}
                        placeholder="Brugernavn eller Email"
                        disabled={loading}
                        showValidationFeedback={false}
                    />
                </div>

                <div>
                    <PasswordInput
                        value={password}
                        onChange={setPassword}
                        error={fieldErrors.password}
                        onValidationChange={setIsPasswordValid}
                        placeholder="Kodeord"
                        disabled={loading}
                        showValidationFeedback={false}
                    />
                </div>

                {error && <div className={styles.error}>{error}</div>}

                <button disabled={loading || !emailOrUsername || !password}>
                    {loading ? 'Logger ind...' : 'Log ind'}
                </button>

                <p className={styles.signup}>
                    Har du ikke en konto? <Link to="/signup">Opret her</Link>
                </p>
            </form>
        </div>
    )
}
